export default "__VITE_ASSET__DlSy$LCP__"